import React from 'react';
import PropTypes from 'prop-types';

import Message from '../common/message/Message';
import Spacer from '../common/spacer/Spacer';
import Text from '../common/text/Text';

export function StepComplete(props) {
    const {
        children
    } = props;

    return (
        <Spacer className="prog__complete" paddingBottom={16}>
            <div className="progstep__header progstep__header--complete">
                <Text
                    as="h3"
                    size={14}
                >
                    <Message fragment code="epic.esport.stepComplete.title" />
                </Text>
            </div>
            {children}
        </Spacer>
    );
}

StepComplete.displayName = 'StepComplete';

StepComplete.propTypes = {
    children: PropTypes.node
};
